module.exports = __webpack_public_path__ + "media/ingredients/broccoli--brown-36d5d277.svg";